jQuery.loadScript = function (url, callback) {
    jQuery.ajax({
        url: url,
        dataType: 'script',
        success: callback,
        async: true
    });
}

function fallbackCopyTextToClipboard(text,callback) {
  var textArea = document.createElement("textarea");
  textArea.value = text;
  
  // Avoid scrolling to bottom
  textArea.style.top = "0";
  textArea.style.left = "0";
  textArea.style.position = "fixed";

  document.body.appendChild(textArea);
  textArea.focus();
  textArea.select();

  try {
    var successful = document.execCommand('copy');
    var msg = successful ? 'successful' : 'unsuccessful';
    // console.log('Fallback: Copying text command was ' + msg);
    callback();
  } catch (err) {
    console.error('Fallback: Oops, unable to copy', err);
  }

  document.body.removeChild(textArea);
}
function copyTextToClipboard(text,callback) {
  if (!navigator.clipboard) {
    fallbackCopyTextToClipboard(text,callback);
    return;
  }
  navigator.clipboard.writeText(text).then(function() {
    // console.log('Async: Copying to clipboard was successful!');
    callback();
  }, function(err) {
    console.error('Async: Could not copy text: ', err);
  });
}
var notify;
function copySuccess(){
	if(!$('#copy-link-success').length){
		notify = $('<h4>',{id:'copy-link-success'});
		notify.text('Link copied to clipboard');
		notify.appendTo('body').hide();
	}
	notify.slideDown(100);
	setTimeout(function(){
		notify.slideUp(100);
	},3000);
}

$(function(){
	var share = $('.share-inline');
	if(share.length){
		var atPlaceholder = $('<div>',{class:'addthis_inline_share_toolbox'})
		atPlaceholder.appendTo('body').hide();
		$.loadScript('//s7.addthis.com/js/300/addthis_widget.js#pubid=ra-5fdca61a49302ad4', function(){
			share.find('a').click(function(){
				var target = $(this).attr('class');
				if(target != 'link'){
				var	$target = $('.at-svc-'+target).find('span');
					$target.trigger('click');					
				} else{
					copyTextToClipboard(window.location,copySuccess);
				}
			})
		});
	}
});